import { Popover } from 'antd'
import styles from './VersionTips.module.scss'
import { useMemo } from 'react'

const VersionTips = (props) => {
    const imgStyle = useMemo(() => {
        if (props.version == 2) {
            return {
                width: 288,
                height: 478,
                marginTop: -32,
                objectFit: 'contain'
            } 
        } else {
            return {   
                width: 267+39,
                height: 155,
                marginLeft: -39,
                objectFit: 'contain'
            }
        }
    }, [props.version, props.isModel])
    return (
        <Popover
            overlayClassName={styles.RefImgPopover}
            arrow={false}
            autoAdjustOverflow={false}
            placement={`${props.version == 2 ? "rightTop" : "topLeft"}`}
            content={
                <img
                    style={imgStyle} 
                    src={
                        props.version == 1 ?
                        require('@assets/images/guide_ref_img_samekind.png') :
                        props.version == 2 ? 
                        (props.isModel ? require('@assets/images/guide_model_custom_scene.png') : require('@assets/images/guide_ref_img_similarity.png')) :
                        require('@assets/images/guide_ref_img_same.png')
                    }
                />
            }
        >
            <i className={styles.RefImg} style={props.isModel ? {top: '17px', right: '20px'} : null}></i>
        </Popover>
    )
}

export default VersionTips